import React, { Component } from 'react'
import { Section, Input, Checkbox } from '../../../../components'
import { STRING } from '../../../../helpers'
import NumberFormat from 'react-number-format'

export default class MaxExtensionTime extends Component {
  render() {
    const {
      formData,
      editRoleDetail,
      isErrMaxExtensionTime,
      isSetState,
    } = this.props
    return (
      <Section className="form-group">
        <label className="max-extension-time">Max Extension Time</label>
        <Section className="form-group-control">
          <Section className="form-group-inner-wrapper">
            <Checkbox
              id="unlimited_extension"
              value="unlimited_extension"
              type="radio"
              name="unlimited_extension"
              disabled={
                !formData.step2.eventInformation.is_ExtensionTime ||
                !editRoleDetail
                  ? true
                  : false
              }
              checked={
                formData.step2.eventInformation.is_ExtensionTime
                  ? !formData.step2.eventInformation.is_MaxExtension
                  : false
              }
              className="inline"
              onChange={e => {
                formData.step2.eventInformation.is_MaxExtension = false
                formData.step2.eventInformation.eventExtensionTime = ''
                isSetState({
                  formData,
                  isErrMaxExtensionTime: false,
                })
              }}
            >
              <div
                className={`checkbox-minimum-bid ${
                  !formData.step2.eventInformation.is_ExtensionTime
                    ? 'checkbox-is-error'
                    : 'max-extension-time'
                } `}
                style={{ width: '105px' }}
              >
                Unlimited
              </div>
            </Checkbox>
            <Section style={{ justifyContent: 'space-between' }}>
              <Checkbox
                id="limited_extension"
                value="limited_extension"
                type="radio"
                name="limited_extension"
                isDisable={
                  !formData.step2.eventInformation.is_ExtensionTime ||
                  !editRoleDetail
                    ? true
                    : false
                }
                checked={
                  formData.step2.eventInformation.is_ExtensionTime
                    ? formData.step2.eventInformation.is_MaxExtension
                    : false
                }
                className="inline limited"
                onChange={e => {
                  formData.step2.eventInformation.is_MaxExtension = true
                  isSetState({
                    formData,
                  })
                }}
              >
                <div
                  className={`checkbox-minimum-bid ${
                    !formData.step2.eventInformation.is_ExtensionTime
                      ? 'checkbox-is-error'
                      : 'max-extension-time'
                  }`}
                >
                  Limited
                </div>
              </Checkbox>
              {/* input Limited Extension Time  */}
              <Section
                className={`form-group ${isErrMaxExtensionTime && 'is-error'}`}
                style={{ width: '60%' }}
              >
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <NumberFormat
                      className="time"
                      placeholder="Times"
                      value={
                        formData.step2.eventInformation.eventExtensionTime
                          ? formData.step2.eventInformation.eventExtensionTime
                          : ''
                      }
                      isAllowed={inputObj => {
                        const { value } = inputObj
                        if (value !== '-') return true
                        return false
                      }}
                      maxLength={11}
                      customInput={Input}
                      decimalScale={0}
                      onValueChange={e => {
                        if (e.floatValue <= 0) {
                          formData.step2.eventInformation.eventExtensionTime = null
                        } else {
                          formData.step2.eventInformation.eventExtensionTime =
                            e.floatValue
                        }
                        isSetState({
                          formData,
                          isErrMaxExtensionTime: false,
                        })
                      }}
                      thousandSeparator={true}
                      readOnly={
                        !formData.step2.eventInformation.is_MaxExtension ||
                        !formData.step2.eventInformation.is_ExtensionTime ||
                        !editRoleDetail
                      }
                    />
                  </Section>
                  {isErrMaxExtensionTime && (
                    <Section className="message">{STRING.INVALID}</Section>
                  )}
                </Section>
              </Section>
            </Section>
          </Section>
          <Section className="message">
            {isErrMaxExtensionTime && STRING.INVALID}
          </Section>
        </Section>
      </Section>
    )
  }
}
